<template>
	<!--  ViewClassroomBoardList.vue: 강의실 > 게시판 > 게시물목록 화면 (notice.html) -->
	<fragment>
		<class-header
			subname="온라인 기획과정>국방부교육"
			name="2019 국방부6기 온라인 기획"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
			v-bind:mainmenuOpened="true"
			v-bind:sysmenuActive="false"
		></class-header>
		<section class="container">
			<nav class="side-nav">
				<a class="btn full-width round m-b-10" href="#none">새로운 설문 추가</a>
				<ul class="side-nav-menu bar clearfix">
					<li>
						<a href="#">찾아가는 국어문화학교(수강생용)</a>
					</li>
				</ul>
			</nav>
			<!-- //end .side-nav -->

			<div class="container-fiuld class-making-box clearfix">
				<br>
				<h3 class="f-18 text-nomal m-t-30 m-b-10">설문 목록</h3>
				<div class="white-box clearfix">
					<p class="f-18 m-b-0 text-bold text-blue">찾아가는 국어문화학교 설문 (신청자용)</p>
					<p class="f-14 m-b-0">대상 : 찾아가는 국어문화학교 신청자</p>
					<p class="f-14 m-b-30 text-right">
						참여 <span class="f-18 text-bold text-blue">31/40</span>
					</p>
					<div class="full-width clearfix">
						<select class="form-control round pull-left">
							<option>진행중</option>
							<option>설문마감</option>
						</select>
						<div class="pull-right">
							<button class="btn round">링크복사</button>
							<button class="btn btn-blue round">결과보기</button>
							<div class="see-more w40 pull-right m-l-10">
								<a class="w40" href="#none">
									<img src="images/see-more.png" width="10" alt="">
								</a>
								<ul>
									<li>설문 직접등록</li>
									<li>설문복사</li>
								</ul>
							</div>
						</div>
					</div>
				</div>

				<div class="white-box clearfix">
					<p class="f-18 m-b-0 text-bold text-blue">찾아가는 국어문화학교 설문 (신청자용)</p>
					<p class="f-14 m-b-0">대상 : 찾아가는 국어문화학교 신청자</p>
					<p class="f-14 m-b-30 text-right">
						참여 <span class="f-18 text-bold text-blue">31/40</span>
					</p>
					<div class="full-width clearfix">
						<select class="form-control round pull-left">
							<option>설문마감</option>
							<option>진행중</option>
						</select>
						<div class="pull-right">
							<button class="btn round">링크복사</button>
							<button class="btn btn-blue round">결과보기</button>
							<div class="see-more w40 pull-right m-l-10">
								<a class="w40" href="#none">
									<img src="images/see-more.png" width="10" alt="">
								</a>
								<ul>
									<li>설문 직접등록</li>
									<li>설문복사</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- //end .container-fuild -->
		</section>
		<modal-class-survey-register :config="modals.classSurveyRegister"></modal-class-survey-register>
		<common-footer></common-footer>
	</fragment>
</template>

<script>
import ModalClassSurveyRegister from '../modals/ModalClassSurveyRegister.vue'
import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import ClassHeader from '../components/ClassHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'
//import CommonSideMenu from '../components/CommonSideMenu.vue'

//import axios from 'axios'
//import server from '../statics/server.js'

export default {
	// 컴포넌트 명
	name: 'ViewSurveyList2',
	mixins: [fnAdjustHeight],
	// 이 컴포넌트에서 사용할 자식컴포넌트 목록
	components: {
		ClassHeader,
		CommonFooter,
		//ModalOnlineClass,
		ModalClassSurveyRegister,
		//CommonSideMenu,
	},
	watch : {
	},
	mounted: function() {

	},

	// 이 컴포넌트에서 내부적으로 사용할 데이터
	data: function() {
		return {
			menus : [
				{name:'강의 목차',link:"/classroom/curriculum",selected:false},
				{name:'수강현황',link:"/classroom/apply/list",selected:false},
				{name:'수료관리',link:"/classroom/finish/test",selected:false},
				{name:'게시판',link:"/classroom/board/register",selected:true},
				{name:'설문',link:"",selected:false},
				{name:'강의정보',link:"",selected:false},
			],
			side_menu_selected : '',
			side_menus: [ // 사이드 메뉴
				{id: '1', name:'국어문화학교 소식',link:"",selected:false},
				{id: '2', name:'묻고답하기',link:"",selected:false},
				{id: '3', name:'자주하는질문',link:"",selected:false},
				{id: '4', name:'자료마당',link:"",selected:false},
			],
			side_buttons : [
				{name:'강의 가져오기', fn:this.onGetCurriculum},
				{name:'신규강의 만들기', fn:this.onCreateCurriculum}
			],
			buttons : [
				{name:'설문 만들기', fn:this.createSurvey},
			],
			create_board : false,
			list_board : false,
			mode : 2,
			modals: {
				classSurveyRegister : ModalClassSurveyRegister.default()
				//ModalOnlineClass: ModalOnlineClass.default()
				//ModalOnlineClass.
			}
		}
	},



	// 이 컴포넌트에서 내부적으로 사용할 메써드
	methods: {
		createSurvey : function(){
			// eslint-disable-next-line
			console.log('createSurvey')
			this.modals.classSurveyRegister.show = true;
		},
		onSaveComplate : function(){
			// eslint-disable-next-line
			console.log('onSaveComplate')
		},
		onCreateCurriculum : function(){ // 신규강의 만들기
			// eslint-disable-next-line
			console.log('onCreateCurriculum');
			//ModalOnlineClass({show :true}) 모달 활성화
			// eslint-disable-next-line
			console.log('this.modals : ', this.modals)
		},
		onGetCurriculum : function(){ // 강의 가져오기
			// eslint-disable-next-line
			console.log('onGetCurriculum')
		},
		createExcute (regist_name){
			// eslint-disable-next-line
			console.log('강의 만들기 : ', regist_name)
		}
	}
}
</script>
<style scope>
	tr {height: 50px;}

	.recycle {
		fill: #fff;
		fill-rule: evenodd;
	}

	.btn-group .btn:hover .recycle {
		fill: #fff;
		fill-rule: evenodd;
	}
</style>
